import React from 'react';
import PropTypes from 'prop-types';
import ExpiredToken from './components/ExpiredToken';
import InvalidToken from './components/InvalidToken';
import UnknownError from './components/UnknownError';
import {Redirect} from 'react-router-dom';
import {InstructionLayout} from '../../../../components/layout/InstructionLayout';


const TOKEN_ERRORS = {
    TOKEN_EXPIRED: 'TOKEN_EXPIRED',
    INVALID_TOKEN: 'INVALID_TOKEN',
    USER_ALREADY_ACTIVATED: 'USER_ALREADY_ACTIVATED'
};

export class ValidateToken extends React.Component {
    static propTypes = {
        validateToken: PropTypes.func.isRequired,
        loading: PropTypes.bool,
        error: PropTypes.any,
        token: PropTypes.string.isRequired,
        onValidToken: PropTypes.func
    };

    state = {
        tokenError: null,
        userId: null,
        email: null
    };

    static defaultProps = {
        onValidToken: () => undefined
    };

    componentDidMount() {
        this.props.validateToken(this.props.token).then(({data: {validateSignupToken}}) => {

            if (validateSignupToken.ok) {
                this.props.onValidToken(validateSignupToken);
            }
            else {
                this.setState({
                    tokenError: validateSignupToken.errorMessage,
                    userId: validateSignupToken.userId,
                    email: validateSignupToken.email
                });
            }
        }).catch(() => {
            this.setState({tokenError: 'INVALID_TOKEN'});
        });
    }

    renderTokenError = () => {
        const {tokenError, userId, email} = this.state;

        if (tokenError === TOKEN_ERRORS.INVALID_TOKEN) {
            return <InvalidToken/>;
        }

        if (tokenError === TOKEN_ERRORS.TOKEN_EXPIRED) {
            return <ExpiredToken userId={userId} email={email}/>;
        }

        if (tokenError === TOKEN_ERRORS.USER_ALREADY_ACTIVATED) {
            return <Redirect to={`/login?email=${encodeURIComponent(email)}&message=${tokenError}`}/>;
        }

        return <UnknownError/>;
    };

    renderError = () => {
        // Server error
        if (this.props.error) {
            console.error(this.props.error);

            return <UnknownError/>;
        }

        if (this.state.tokenError) {
            return this.renderTokenError();
        }

        // This should never happen
        return <div/>;
    };

    render() {
        return (
            <InstructionLayout loading={this.props.loading} instruction={<div/>}>
                {this.renderError()}
            </InstructionLayout>
        );

    }
}

export default ValidateToken;
